import { Menu, ArrowBack } from "@mui/icons-material"
import {
  Avatar,
  Box,
  IconButton,
  Stack,
  SvgIcon,
  Tooltip,
  Typography,
  useMediaQuery
} from "@mui/material"
import { alpha } from "@mui/material/styles"
import { usePopover } from "../hooks/use-popover"
import AccountPopover from "./AccountPopover"
import { useSelector } from "react-redux"
import { getUser } from "../../store/auth/auth.selectors"
import { useLocation, useNavigate } from "react-router"
import { SIDE_NAV_COLLAPSED_WIDTH, TOP_NAV_HEIGHT } from "../constants"

// Page title mapping based on routes
const PAGE_TITLES = {
  "/admin/organizations": "Organizations",
  "/admin/pending-requests": "Pending Requests",
  "/admin/insights": "Insights",
  "/admin/coupons": "Coupons",
  "/admin/push-notifications": "Push Notifications"
}

const TopNav = (props) => {
  const { onNavOpen } = props
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"))
  const accountPopover = usePopover()
  const nav = useNavigate()
  const { pathname } = useLocation()

  const userData = useSelector(getUser)

  const handleReturn = () => nav("/")

  // Get page title based on current route
  const pageTitle = PAGE_TITLES[pathname] || "Admin Panel"

  return (
    <>
      <Box
        component="header"
        sx={{
          backdropFilter: "blur(8px)",
          backgroundColor: (theme) => alpha(theme.palette.background.default, 0.85),
          position: "sticky",
          left: {
            lg: `${SIDE_NAV_COLLAPSED_WIDTH}px`
          },
          top: 0,
          width: {
            lg: `calc(100% - ${SIDE_NAV_COLLAPSED_WIDTH}px)`
          },
          zIndex: 100,
          borderBottom: "1px solid",
          borderColor: "divider"
        }}
      >
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          spacing={2}
          sx={{
            minHeight: TOP_NAV_HEIGHT,
            px: 3
          }}
        >
          <Stack alignItems="center" direction="row" spacing={2}>
            {!lgUp && (
              <IconButton onClick={onNavOpen} size="small">
                <SvgIcon fontSize="small">
                  <Menu />
                </SvgIcon>
              </IconButton>
            )}
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                color: "text.primary",
                fontSize: "20px"
              }}
            >
              {pageTitle}
            </Typography>
          </Stack>
          <Stack alignItems="center" direction="row" spacing={1}>
            <Tooltip title="Back to App">
              <IconButton
                onClick={handleReturn}
                size="small"
                sx={{
                  backgroundColor: "neutral.100",
                  "&:hover": { backgroundColor: "neutral.200" }
                }}
              >
                <SvgIcon fontSize="small" sx={{ fontSize: 18 }}>
                  <ArrowBack />
                </SvgIcon>
              </IconButton>
            </Tooltip>
            <Avatar
              onClick={accountPopover.handleOpen}
              ref={accountPopover.anchorRef}
              sx={{
                cursor: "pointer",
                height: 34,
                width: 34,
                border: "2px solid",
                borderColor: "neutral.200",
                transition: "border-color 0.15s ease",
                "&:hover": { borderColor: "primary.main" }
              }}
              src={userData.avatar}
            />
          </Stack>
        </Stack>
      </Box>
      <AccountPopover
        anchorEl={accountPopover.anchorRef.current}
        open={accountPopover.open}
        onClose={accountPopover.handleClose}
      />
    </>
  )
}

export default TopNav
